import { FC, useState, useEffect } from 'react';
import { useStore } from 'hooks/useRootStore';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { useMutation, useQuery } from 'react-query';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import {
  Paper,
  Grid,
  Container,
  Button,
  TextField,
  NativeSelect,
  FormHelperText,
  FormControlLabel,
} from '@material-ui/core';
import { useStyles } from './styles';
import { AdminFormInputPattern, AdminData, AdminFormProps } from './types';
import { observer } from 'mobx-react-lite';
import { handleCompanyUrl } from 'utils/organizationUtils';
import ProfileIcon from './../../../../../assets/icons/AdminIcons/Profile.svg';
import LockIcon from './../../../../../assets/icons/AdminIcons/Lock.svg';
import GlobeIcon from './../../../../../assets/icons/AdminIcons/Globe.svg';
import Email from './../../../../../assets/icons/EndUser/Email.svg';
import DescriptionIcon from './../../../../../assets/icons/AdminIcons/Description.svg';
import PhoneIcon from './../../../../../assets/icons/AdminIcons/PhoneIcon.svg';
import HomeAddressIcon from './../../../../../assets/icons/AdminIcons/HomeAddressIcon.svg';
import MuiPhoneNumber from 'material-ui-phone-number-2';
import Calender from './../../../../../assets/icons/EndUser/Calender.svg';
import { toFormatDateTime } from 'utils';
import { Autocomplete } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import { InputLabel } from '@material-ui/core';

export const AdminDataForm: FC<AdminFormProps> = observer(({ selfRegister, type, currentUserData }) => {
  const { control, handleSubmit, reset } = useForm<AdminData>();
  const [typeForm] = useState<string>(type ?? '');
  const [currentUser, setCurrentUser] = useState(currentUserData);
  const [emailValid, setEmailValid] = useState<boolean>(true);
  const [passwordValid, setPasswordValid] = useState<boolean>(true);
  const [currentUserAllGroup, setcurrentUserAllGroup] = useState([]);
  const [passwordStatus, setPasswordStatus] = useState<string>('');
  const [selectedGroups, setSelectedGroups] = useState<any[]>([]);
  const [arrayValid, setArrayValid] = useState<boolean>(false);
  const [inputValue, setInputValue] = useState<string>('');
  const [passLowerCase, setPassLowerCase] = useState<number>(0);
  const [passUpperCase, setPassUpperCase] = useState<number>(0);
  const [passNumericCase, setPassNumericCase] = useState<number>(0);
  const [passSpecialCase, setPassSpecialCase] = useState<number>(0);
  const [minPass, SetMinPass] = useState<number>(0);
  const profile = JSON.parse(localStorage.getItem('Profile') as string);
  const [inputValues, setInputValues] = useState({
    givenname: currentUser?.givenname || '',
    sn: currentUser?.sn || '',
    displayname: currentUser?.displayname || '',
    uid: currentUser?.uid || '',
  });

  const [validation, setValidation] = useState({
    givenname: true,
    sn: true,
    displayname: true,
    uid: true,
  });
  const handleValidation = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {
    const value = e.target.value;
    let reg, isValid: boolean;

    if (key === 'uid') {
      reg = /^[0-9a-zA-Z_]+$/;
      isValid = value.trim() !== '' && reg.test(value);
    } else {
      reg = /^[A-Za-z]+$/;
      isValid = value.trim() !== '' && reg.test(value);
    }

    setInputValues((prev) => ({ ...prev, [key]: value }));
    setValidation((prev) => ({ ...prev, [key]: isValid }));
  };
  const handleEmailValidation = (e: any) => {
    const reg = new RegExp(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/);
    setEmailValid(reg.test(e.target.value));
  };
  const passwordPattern = new RegExp(
    `^(?=(?:.*[A-Z]){${passUpperCase},})(?=(?:.*[a-z]){${passLowerCase},})(?=(?:.*\\d){${passNumericCase},})(?=(?:.*[!@#$%^&*()_+={}[]|\\:;"'<>,.?/~\`-]){${passSpecialCase},}).{${minPass},}$`
  );
  const handlePasswordValidation = (e: any) => {
    const value = e.target.value;
    const isEmpty = value.trim() === '';
    const isValid = isEmpty || passwordPattern.test(value);
    setPasswordValid(isValid);
    setInputValue(value);
    setPasswordStatus('yes');
  };

  useEffect(() => {
    setCurrentUser((prev) => currentUserData);
  }, [currentUserData]);
  useEffect(() => {
    if (typeForm === 'add' || !currentUserData) {
      reset({});
      setCurrentUser(undefined);
      setInputValues({
        givenname: '',
        sn: '',
        displayname: '',
        uid: '',
      });
    } else if (currentUserData) {
      const userData: AdminData = {
        ...currentUserData,
        uid: currentUserData.uid ?? '',
        givenname: currentUserData.givenname ?? '',
        notify: currentUserData.notify ?? true,
      };
      reset(userData);
      setCurrentUser(currentUserData);
    }
  }, [currentUserData, reset, typeForm]);

  const {
    ldapStore: {
      updateUser,
      createUser,
      endUserSelfRegister,
      departmentsView,
      getDepartments,
      getGroups,
      allGroupsView,
    },
    endUserSettingsFormStore: { portalSettingsget, getSettings, settingsByTypeView },
    adminFormStore: { roles },
    notificationStore: { openNotification },
    appPreloaderStore: { disablePreloader },
  } = useStore();

  const classes = useStyles();
  const history = useHistory();
  const getDepartmentsReq = useQuery('getDepartmentsReq', () => getDepartments(), {
    onError: () => openNotification('error', `Can't get departments`),
  });
  const getGroupsReq = useQuery('getGroupsReq', () => getGroups(), {
    onError: () => openNotification('error', `Can't get groups`),
  });
  const portalSettingsgetReq = useQuery('portalSettingsgetReq', () => portalSettingsget(), {
    onError: () => openNotification('error', `Can't get data`),
  });
  const getSettingsReq = useQuery('getSettingReq', () => getSettings(), {
    onError: () => openNotification('error', `Can't get password policy`),
  });
  useEffect(() => {
    settingsByTypeView('password').forEach((group: any, i: any) =>
      group.settings.forEach((setting: any, j: any) => {
        if (setting.key === 'minimumNumberOfLowercaseCharacters') {
          return setPassLowerCase(+setting.value);
        } else if (setting.key === 'minimumNumberOfUppercaseCharacters') {
          return setPassUpperCase(+setting.value);
        } else if (setting.key === 'minimumNumberOfNumericCharacters') {
          return setPassNumericCase(+setting.value);
        } else if (setting.key === 'minimumNumberOfSpecialCharacters') {
          return setPassSpecialCase(+setting.value);
        } else if (setting.key === 'minimumLengthPassword') {
          return SetMinPass(+setting.value);
        } else {
          return 0;
        }
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getSettingsReq.isFetching]);

  const updateUserReq = useMutation((data: AdminData) => updateUser(data, passwordStatus), {
    mutationKey: 'updateUserReq',
    onSuccess: () => {
      openNotification('success', 'Saved!!');
      if (currentUser) {
        localStorage.removeItem('ClickedUser');
      }
      history.push(handleCompanyUrl('/admins'));
    },
    onError: ({ message }: Error) => openNotification('error', message),
  });
  const goBack = () => {
    localStorage.removeItem('ClickedUser');
    history.goBack();
  };
  const permission = profile?.permission;
  const createUserReq = useMutation(
    (data: AdminData) => (selfRegister ? endUserSelfRegister(data) : createUser(data)),
    {
      mutationKey: 'createUserReq',
      onSuccess: () => {
        openNotification('success', 'Created Successfully');
        if (currentUser) {
          localStorage.removeItem('ClickedUser');
        }
        if (!selfRegister) {
          history.push(handleCompanyUrl('/admins'));
        } else {
          disablePreloader();
          history.replace(handleCompanyUrl('/'));
        }
      },
      onError: (error: any) => {
        disablePreloader();
        openNotification('error', error?.message);
        if (error.licensePage) {
          history.replace(handleCompanyUrl('/upgrade-license'));
        }
      },
    }
  );
  const endUserConfigSettings = JSON.parse(localStorage.getItem('endUserConfigSettings') as string);

  useAppPreloader(
    updateUserReq.isLoading ||
      createUserReq.isLoading ||
      getDepartmentsReq.isFetching ||
      getGroupsReq.isFetching ||
      portalSettingsgetReq.isFetching ||
      getSettingsReq.isFetching
  );
  useEffect(() => {
    const tempcurrentUserAllGroup: any = [];
    allGroupsView.forEach((group) => {
      if (Array.isArray(group.memberuid)) {
        group.memberuid.forEach((element) => {
          if (element === currentUser?.dn) {
            if (group?.dn && !tempcurrentUserAllGroup.includes(group.dn)) {
              tempcurrentUserAllGroup.push(group.dn);
            }
          }
        });
      }
    });
    setcurrentUserAllGroup(tempcurrentUserAllGroup);
  }, [allGroupsView, currentUser?.dn]);

  useEffect(() => {
    const mappedGroups = currentUserAllGroup.map((dn) => {
      const group = allGroupsView.find((item) => item.dn === dn);
      return { dn, label: group?.cn };
    });
    setSelectedGroups(mappedGroups);
  }, [allGroupsView, currentUserAllGroup]);

  const handleGroupChange = (event: React.SyntheticEvent, newValue: any[]) => {
    const uniqueGroups = newValue.filter((group, index, self) => index === self.findIndex((g) => g.dn === group.dn));
    setSelectedGroups(uniqueGroups);
  };
  function arraysAreIdentical(arr1: any, arr2: any) {
    if (arr1.length !== arr2.length) {
      return false;
    }
    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) {
        return false;
      }
    }
    return true;
  }
  useEffect(() => {
    const array1 = currentUserAllGroup;
    const transformedGroups = selectedGroups.map((group) => group.dn);
    const array2 = transformedGroups;
    const array = arraysAreIdentical(array1, array2);
    setArrayValid(array);
  }, [currentUserAllGroup, selectedGroups]);
  const onSubmit = (data: AdminData) => {
    delete data.locked;
    const transformedGroups = selectedGroups.map((group) => group.dn);
    data.group = transformedGroups;
    data.oldgroup = arrayValid ? [] : currentUserAllGroup;
    data.base = data.base || '/';
    data.appStatus = data.googleId || data.zoomId ? true : false;
    data.googleId = data.googleId ? data.googleId : '';
    data.zoomId = data.zoomId ? data.zoomId : '';
    data.reSyncProvider = data.reSyncProvider ? data.reSyncProvider : [];
    data.role = data.carlicense;
    (!!currentUser as boolean) ? (data.updatedBy = permission) : (data.createdBy = permission);
    (!!currentUser as boolean) ? updateUserReq.mutate(data) : createUserReq.mutate(data);
  };

  const mockDataPers1: AdminFormInputPattern[] = [
    { label: 'First name', key: 'givenname', required: true, icon: ProfileIcon, autoFocus: true },
    { label: 'Middle name', key: 'displayname', required: false, icon: ProfileIcon },
    { label: 'Last name', key: 'sn', required: true, icon: ProfileIcon },
    {
      label:
        endUserConfigSettings?.userId === null || endUserConfigSettings?.userId === ''
          ? 'User Id'
          : endUserConfigSettings?.userId,
      key: 'uid',
      required: true,
      disable: typeForm === 'edit' || typeForm === 'view' ? true : false,
      pattern: {
        regexp: /^[0-9a-zA-Z_]+$/,
        errorMessage: 'The UID must not contain spaces or special characters',
      },
      icon: ProfileIcon,
    },
    ...(typeForm === 'view'
      ? []
      : [
          {
            label: 'Password',
            key: 'userpassword' as keyof AdminData,
            pattern: {
              regexp: passwordPattern,
              errorMessage: `Password must contain at least ${passUpperCase} uppercase, ${passLowerCase} lowercase, ${passSpecialCase} special characters, ${passNumericCase} numeric value(s), and minimum ${minPass} characters.`,
            },
            required: !currentUser as boolean,
            icon: LockIcon,
          },
        ]),
    {
      label: 'Email',
      key: 'mail',
      pattern: {
        regexp: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        errorMessage: 'Please enter a valid email address',
      },
      icon: Email,
      required: true,
      disable: typeForm === 'edit' || typeForm === 'view' ? true : false,
    },

    { label: 'CN', key: 'cn', required: false, disable: true },
    { label: 'DN', key: 'dn', required: false, disable: true },
    {
      label: 'Preferred language',
      key: 'preferredlanguage',
      type: 'select',
      defaultValue: 'en_US',
      icon: GlobeIcon,
      options: [
        { value: 'af_ZA', label: 'Afrikaans (Afrikaans)' },
        { value: 'ar_EG', label: 'Arabic (عربية)' },
        { value: 'pt_BR', label: 'Brazilian (Português (Brasil))' },
        { value: 'ca_ES', label: 'Catalan (Català)' },
        { value: 'zh_CN', label: 'Chinese (中文, 汉语, 漢語)' },
        { value: 'es_CO', label: 'Colombian Spanish (Español Colombiano)' },
        { value: 'cs_CZ', label: 'Czech (Česky)' },
        { value: 'nl_NL', label: 'Dutch (Nederlands)' },
        { value: 'en_US', label: 'English (English)' },
        { value: 'fi_FI', label: 'Finnish (Suomi)' },
        { value: 'fr_FR', label: 'French (Français)' },
        { value: 'de_DE', label: 'German (Deutsch)' },
        { value: 'el_GR', label: 'Greek (ελληνικά)' },
        { value: 'hu_HU', label: 'Hungarian (Magyar)' },
        { value: 'id_ID', label: 'Indonesian (Bahasa Indonesia)' },
        { value: 'it_IT', label: 'Italian (Italiano)' },
        { value: 'ja_JP', label: 'Japanese (日本語)' },
        { value: 'ko_KR', label: 'Korean (한국어)' },
        { value: 'lv_LV', label: 'Latvian (Latviešu valoda)' },
        { value: 'nb_NO', label: 'Norwegian Bokmål (Norsk bokmål)' },
        { value: 'fa_IR', label: 'Persian (پارسی)' },
        { value: 'pl_PL', label: 'Polish (Polski)' },
        { value: 'pt_PT', label: 'Portuguese (Português)' },
        { value: 'ru_RU', label: 'Russian (русский язык)' },
        { value: 'es_ES', label: 'Spanish (Español)' },
        { value: 'sv_SE', label: 'Swedish (Svenska)' },
        { value: 'zh_TW', label: 'Taiwanese (Taiwanese)' },
        { value: 'tr_TR', label: 'Turkish (Türkçe)' },
        { value: 'es_VE', label: 'Venezuelan (Castellano)' },
        { value: 'vi_VN', label: 'Vietnamese (Tiếng Việt)' },
      ],
    },
    { label: 'Description', key: 'description', icon: DescriptionIcon },
  ];

  const mockDataPers2: AdminFormInputPattern[] = [
    { label: 'Address', key: 'homepostaladdress', placeholder: 'Address', icon: HomeAddressIcon },
    { label: 'Private phone', key: 'homephone', placeholder: 'Phone Number', icon: PhoneIcon },
    ...(typeForm === 'view'
      ? [
          {
            label: 'Created',
            key: 'createtimestamp' as keyof AdminData,
            required: !currentUser as boolean,
            icon: Calender,
          },
          {
            label: 'Last Updated',
            key: 'modifytimestamp' as keyof AdminData,
            required: !currentUser as boolean,
            icon: Calender,
          },
        ]
      : []),
  ];

  const getCNFromDN = (selectedDNs: any, allGroupsView: any) => {
    return selectedDNs.map((selectedDN: any) => {
      const foundGroup = allGroupsView.find((group: any) => group.dn === selectedDN);
      return foundGroup ? foundGroup.cn : selectedDN;
    });
  };

  const getRoleLabel = (roleValue: string) => {
    const roleMap: { [key: string]: string } = {
      billing_admin: 'Billing Administrator',
      system_admin: 'System Administrator',
    };
    return roleMap[roleValue] || roleValue;
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className={classes.box}>
      <Grid container justify='space-between'>
        <Paper className={classes.paper}>
          <p className={classes.boxTitle}>General Information</p>
          <Grid container>
            <Container className={classes.tableBox}>
              {mockDataPers1.map((item, index) => (
                <Controller
                  name={item.key}
                  key={index}
                  defaultValue={item.key !== 'userpassword' ? currentUser?.[item.key] || item?.defaultValue : undefined}
                  control={control}
                  rules={{ required: item?.required }}
                  render={({ field, fieldState: { invalid, error } }) => (
                    <Grid key={index} container className={item?.multiline ? classes.rowWide : classes.row}>
                      {item.type === 'select' ? (
                        <FormControl
                          className={invalid ? classes.inputError : classes.input}
                          style={{ display: 'flex', flexDirection: 'row', gap: '8px' }}
                        >
                          <span style={{ display: 'flex' }}>
                            <img src={item.icon} alt='' />
                          </span>
                          <NativeSelect
                            {...field}
                            error={invalid}
                            fullWidth
                            disabled={type === 'view'}
                            autoFocus={item?.autoFocus}
                          >
                            {item?.options
                              ? item.options.map((item) => (
                                  <option key={item.value} value={item.value}>
                                    {item.label}
                                  </option>
                                ))
                              : null}
                          </NativeSelect>
                          {invalid ? <FormHelperText error>Required field</FormHelperText> : null}
                        </FormControl>
                      ) : item.key === 'givenname' || item.key === 'sn' || item.key === 'displayname' ? (
                        <div style={{ display: 'flex', width: '100%', gap: '8px' }}>
                          <span style={{ display: 'flex' }}>
                            <img src={item.icon} alt='' />
                          </span>
                          <TextField
                            {...field}
                            variant='standard'
                            label={item.label}
                            defaultValue={currentUser?.[item.key]}
                            autoFocus={item?.autoFocus}
                            className={invalid ? classes.inputError : classes.input}
                            multiline={item?.multiline}
                            rows={item?.multiline ? 4 : 1}
                            placeholder={item.placeholder}
                            onChangeCapture={(e: any) => handleValidation(e, item.key)}
                            error={!validation[item.key]}
                            disabled={type === 'view' || item.disable}
                            helperText={
                              !validation[item.key] && inputValues[item.key].trim() !== ''
                                ? 'There must be no space at the start, no numeric values, and no special characters'
                                : invalid
                                ? error?.type === 'pattern'
                                  ? item.pattern?.errorMessage
                                  : 'Required field'
                                : ''
                            }
                          />
                        </div>
                      ) : item.key === 'mail' ? (
                        <div style={{ display: 'flex', width: '100%', gap: '8px' }}>
                          <span style={{ display: 'flex' }}>
                            <img src={item.icon} alt='' />
                          </span>
                          <TextField
                            {...field}
                            variant='standard'
                            label={item.label}
                            defaultValue={currentUser?.[item.key]}
                            autoFocus={item?.autoFocus}
                            className={invalid ? classes.inputError : classes.input}
                            multiline={item?.multiline}
                            rows={item?.multiline ? 4 : 1}
                            placeholder={item.placeholder}
                            onChangeCapture={(e: any) => handleEmailValidation(e)}
                            error={invalid || (!emailValid && item.key === 'mail')}
                            disabled={type === 'view' || type === 'edit' || item.disable}
                            helperText={
                              !emailValid && item.key === 'mail'
                                ? 'Please enter valid email address'
                                : invalid
                                ? error?.type === 'pattern'
                                  ? item.pattern?.errorMessage
                                  : 'Required field'
                                : ' '
                            }
                          />
                        </div>
                      ) : item.key === 'userpassword' ? (
                        <div style={{ display: 'flex', width: '100%', gap: '8px' }}>
                          <span style={{ display: 'flex' }}>
                            <img src={item.icon} alt='' />
                          </span>
                          <TextField
                            {...field}
                            variant='standard'
                            label={item.label}
                            defaultValue={currentUser?.[item.key]}
                            autoFocus={item?.autoFocus}
                            className={invalid ? classes.inputError : classes.input}
                            multiline={item?.multiline}
                            rows={item?.multiline ? 4 : 1}
                            placeholder={item.placeholder}
                            onChangeCapture={(e: any) => handlePasswordValidation(e)}
                            error={invalid || (!passwordValid && inputValue.trim() !== '')}
                            disabled={type === 'view' || item.disable}
                            helperText={
                              !passwordValid && inputValue.trim() !== ''
                                ? `Password must contain at least ${passUpperCase} uppercase, ${passLowerCase} lowercase, ${passSpecialCase} special characters, ${passNumericCase} numeric value(s), and minimum ${minPass} characters.`
                                : invalid
                                ? error?.type === 'pattern'
                                  ? item.pattern?.errorMessage
                                  : 'Required field'
                                : ''
                            }
                          />
                        </div>
                      ) : item.key === 'uid' ? (
                        <div style={{ display: 'flex', width: '100%', gap: '8px' }}>
                          <span style={{ display: 'flex' }}>
                            <img src={item.icon} alt='' />
                          </span>
                          <TextField
                            {...field}
                            variant='standard'
                            label={item.label}
                            defaultValue={currentUser?.[item.key]}
                            autoFocus={item?.autoFocus}
                            className={invalid ? classes.inputError : classes.input}
                            multiline={item?.multiline}
                            rows={item?.multiline ? 4 : 1}
                            placeholder={item.placeholder}
                            onChangeCapture={(e: any) => handleValidation(e, item.key)}
                            error={invalid || !validation[item.key]}
                            disabled={type === 'view' || item.disable}
                            helperText={
                              !validation[item.key] && inputValues[item.key].trim() !== ''
                                ? 'The UID must not contain spaces or special characters'
                                : invalid
                                ? error?.type === 'pattern'
                                  ? item.pattern?.errorMessage
                                  : 'Required field'
                                : ''
                            }
                          />
                        </div>
                      ) : (
                        <div style={{ display: 'flex', width: '100%', gap: '8px' }}>
                          <span style={{ display: 'flex' }}>
                            <img src={item.icon} alt='' />
                          </span>
                          <TextField
                            {...field}
                            variant='standard'
                            label={item.label}
                            defaultValue={currentUser?.[item.key]}
                            autoFocus={item?.autoFocus}
                            className={invalid ? classes.inputError : classes.input}
                            multiline={item?.multiline}
                            rows={item?.multiline ? 4 : 1}
                            placeholder={item.placeholder}
                            error={invalid}
                            disabled={type === 'view' || item.disable}
                            helperText={
                              invalid ? (error?.type === 'pattern' ? item.pattern?.errorMessage : 'Required field') : ''
                            }
                          />
                        </div>
                      )}
                    </Grid>
                  )}
                />
              ))}
            </Container>
            <Controller
              name='carlicense'
              defaultValue=''
              control={control}
              rules={{ required: true }}
              render={({ field, fieldState: { invalid, error } }) => (
                <Grid key='permission' container className={classes.row}>
                  <div style={{ display: 'flex', width: '100%', gap: '8px' }}>
                    <span style={{ display: 'flex' }}>
                      <img src={ProfileIcon} alt='' />
                    </span>
                    <FormControl fullWidth variant='standard' error={invalid}>
                      {type === 'view' && !roles.includes(field.value) ? (
                        <TextField
                          {...field}
                          variant='standard'
                          label='Role'
                          value={getRoleLabel(field.value)}
                          disabled={type === 'view'}
                          autoComplete='permission'
                          autoFocus
                          style={{ width: '97%' }}
                          helperText={invalid ? 'Required field' : ''}
                          error={invalid}
                        />
                      ) : (
                        <>
                          <InputLabel htmlFor='role-select'>Application Role</InputLabel>
                          <NativeSelect
                            {...field}
                            value={field.value || currentUser?.carlicense || ''}
                            onChange={(e) => field.onChange(e)}
                            inputProps={{
                              name: 'permission',
                              id: 'role-select',
                            }}
                            disabled={type === 'view'}
                          >
                            <option aria-label='None' value='' />
                            <option value='billing_admin'>Billing Administrator</option>
                            <option value='system_admin'>System Administrator</option>
                          </NativeSelect>
                        </>
                      )}
                      {invalid && <FormHelperText error>Required field</FormHelperText>}
                    </FormControl>
                  </div>
                </Grid>
              )}
            />
          </Grid>
        </Paper>
        <Paper className={classes.paper}>
          <p className={classes.boxTitle}>Personal Information</p>
          <Container className={classes.tableBox}>
            {mockDataPers2.map((item, index) =>
              item.key === 'homephone' ? (
                <Controller
                  key={index}
                  name={item.key}
                  defaultValue={
                    currentUser?.telephonenumber
                      ? currentUser?.telephonenumber
                      : item.key
                      ? currentUser?.[item.key]
                      : undefined
                  }
                  control={control}
                  rules={{ required: item?.required }}
                  render={({ field, fieldState: { invalid, error } }) => (
                    <FormControl fullWidth>
                      <Grid
                        key={index}
                        container
                        style={{ display: 'flex', gap: '8px' }}
                        className={item?.multiline ? classes.rowWide : classes.row}
                      >
                        <img src={item.icon} alt='' />
                        <MuiPhoneNumber
                          {...field}
                          label={item.label}
                          disabled={type === 'view'}
                          autoFocus={item?.autoFocus}
                          className={classes.inputTwo}
                          multiline={item?.multiline}
                          rows={item?.multiline ? 4 : 1}
                          placeholder={item.placeholder}
                          error={invalid}
                          helperText={
                            invalid ? (error?.type === 'pattern' ? item.pattern?.errorMessage : 'Required field') : ''
                          }
                          data-cy='user-phone'
                          defaultCountry={'us'}
                          variant='standard'
                          color='warning'
                        />
                      </Grid>
                    </FormControl>
                  )}
                />
              ) : item.key === 'createtimestamp' || item.key === 'modifytimestamp' ? (
                <Controller
                  key={index}
                  name={item.key}
                  defaultValue={item.key ? currentUser?.[item.key] : undefined}
                  control={control}
                  rules={{ required: item?.required }}
                  render={({ field, fieldState: { invalid, error } }) => (
                    <Grid
                      key={index}
                      container
                      style={{ display: 'flex', gap: '8px' }}
                      className={item?.multiline ? classes.rowWide : classes.row}
                    >
                      <img src={item.icon} alt='' />
                      <TextField
                        {...field}
                        variant='standard'
                        label={item.label}
                        disabled={type === 'view'}
                        autoFocus={item?.autoFocus}
                        className={classes.inputTwo}
                        multiline={item?.multiline}
                        rows={item?.multiline ? 4 : 1}
                        placeholder={item.placeholder}
                        value={toFormatDateTime(field.value)}
                        error={invalid}
                        helperText={
                          invalid ? (error?.type === 'pattern' ? item.pattern?.errorMessage : 'Required field') : ''
                        }
                      />
                    </Grid>
                  )}
                />
              ) : (
                <Controller
                  key={index}
                  name={item.key}
                  defaultValue={item.key ? currentUser?.[item.key] : undefined}
                  control={control}
                  rules={{ required: item?.required }}
                  render={({ field, fieldState: { invalid, error } }) => (
                    <Grid
                      key={index}
                      container
                      style={{ display: 'flex', gap: '8px' }}
                      className={item?.multiline ? classes.rowWide : classes.row}
                    >
                      <img src={item.icon} alt='' />
                      <TextField
                        {...field}
                        variant='standard'
                        label={item.label}
                        disabled={type === 'view'}
                        autoFocus={item?.autoFocus}
                        className={classes.inputTwo}
                        multiline={item?.multiline}
                        rows={item?.multiline ? 4 : 1}
                        placeholder={item.placeholder}
                        error={invalid}
                        helperText={
                          invalid ? (error?.type === 'pattern' ? item.pattern?.errorMessage : 'Required field') : ''
                        }
                      />
                    </Grid>
                  )}
                />
              )
            )}
          </Container>
        </Paper>
        <Paper className={classes.paper}>
          <Container className={classes.tableBox}>
            <p className={classes.boxTitle}>Department</p>
            <>
              {!getDepartmentsReq.isFetching && (
                <>
                  <Grid className={classes.row} container justify='space-between'>
                    {departmentsView.length === 0 ? (
                      <div>
                        <span>No Departments Found.</span>
                        <Button onClick={() => history.push(handleCompanyUrl('/department/add'))}>
                          Add Department
                        </Button>
                      </div>
                    ) : (
                      <Controller
                        name='base'
                        key={'base'}
                        control={control}
                        defaultValue={currentUser ? currentUser?.ou : ''}
                        render={({ field }) => (
                          <Autocomplete
                            {...field}
                            className={classes.inputTwo}
                            options={departmentsView}
                            disablePortal
                            disabled={type === 'view'}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant='outlined'
                                className={classes.inputTwo}
                                disabled={type === 'view'}
                              />
                            )}
                            getOptionLabel={(option) => option.ou || ''}
                            onChange={(e, value) => {
                              const selectedValue = value ? `${value.base}` || '' : '';
                              field.onChange(selectedValue);
                            }}
                            value={departmentsView.find((option) => `${option.base}` === field.value) || null}
                          />
                        )}
                      />
                    )}
                  </Grid>
                </>
              )}
              {getDepartmentsReq.isFetching && <div>Loading...</div>}
            </>
          </Container>
        </Paper>
        <Paper className={classes.paper}>
          <p className={classes.boxTitle}>Groups</p>
          <Container className={classes.tableBox}>
            <>
              {!getGroupsReq.isFetching && (
                <>
                  <Grid className={classes.row} container justify='space-between'>
                    {allGroupsView.length === 0 ? (
                      <div>
                        <span>No Group Found.</span>
                        <Button onClick={() => history.push(handleCompanyUrl('/groups/add'))}>Add Group</Button>
                      </div>
                    ) : (
                      <>
                        <>
                          <FormControl fullWidth>
                            <Autocomplete
                              multiple
                              options={allGroupsView.map((group) => ({
                                dn: group.dn,
                                label: group.cn,
                                email: group.email,
                              }))}
                              value={selectedGroups}
                              disablePortal
                              getOptionLabel={(option) => option.label}
                              onChange={handleGroupChange}
                              disabled={type === 'view'}
                              renderOption={(props, option) => (
                                <li {...props}>
                                  <Checkbox checked={selectedGroups.some((group) => group.dn === option.dn)} />
                                  <ListItemText primary={option.label} />
                                </li>
                              )}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  variant='outlined'
                                  className={classes.inputTwo}
                                  disabled={type === 'view'}
                                />
                              )}
                            />
                          </FormControl>
                        </>
                        <Controller
                          name='oldgroup'
                          control={control}
                          render={({ field }) => (
                            <Select
                              {...field}
                              multiple
                              value={currentUserAllGroup}
                              onChange={(e) => field.onChange(e.target.value)}
                              className={classes.inputTwo}
                              style={{ display: 'none' }}
                              disabled={type === 'view'}
                              renderValue={(selected: any) => (
                                <div>
                                  {getCNFromDN(selected as string[], allGroupsView).map((value: any) => (
                                    <span key={value}>{value} </span>
                                  ))}
                                </div>
                              )}
                            >
                              {allGroupsView.map((group) => (
                                <MenuItem key={group.dn} value={group.dn}>
                                  <Checkbox checked={field.value?.includes(group.dn)} />
                                  {group.cn}
                                </MenuItem>
                              ))}
                            </Select>
                          )}
                        />
                      </>
                    )}
                  </Grid>
                </>
              )}
              {getGroupsReq.isFetching && <div>Loading...</div>}
            </>
          </Container>
        </Paper>
      </Grid>
      {type === 'view' ? (
        ''
      ) : (
        <FormControlLabel
          className={classes.notify}
          control={
            <Controller
              name='notify'
              defaultValue={currentUser?.notify}
              key={'notify'}
              control={control}
              render={({ field, fieldState: { invalid, error } }) => (
                <Checkbox
                  disabled={type === 'view'}
                  {...field}
                  defaultChecked={currentUser?.notify}
                  onChange={field.onChange}
                  name='notify'
                />
              )}
            />
          }
          label='Notify User via Email'
        />
      )}
      {type === 'view' ? (
        ''
      ) : (
        <div className={classes.btnBox}>
          {!selfRegister ? (
            <Button
              type='button'
              variant='contained'
              color='primary'
              className={classes.btnWideLeft}
              onClick={() => goBack()}
            >
              Cancel
            </Button>
          ) : null}
          <Button
            type='submit'
            variant='contained'
            color='secondary'
            className={classes.btnWide}
            disabled={!emailValid || !passwordValid || !validation.givenname || !validation.sn || !validation.uid}
          >
            {(!!currentUser as boolean) ? 'Save Changes' : 'Create'}
          </Button>
          {selfRegister ? (
            <Link className={classes.link} to='/'>
              Back 2
            </Link>
          ) : null}
        </div>
      )}
    </form>
  );
});
